"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllVirtualCategories = void 0;
const routes_1 = require("../../routes");
const getAllVirtualCategories = (client) => async (params) => {
    const url = routes_1.ENDPOINTS.GET_ALL_VIRTUAL_CATEGORIES.applyParams(params);
    const response = await client.get(url);
    return response.data;
};
exports.getAllVirtualCategories = getAllVirtualCategories;
